import React from "react";
import PropTypes from "prop-types";
import { OverlaySlider } from "../../Components/OverlaySlider";

export function Option(props) {
  const onSliderChange = (event) => {
    props.updateSelection({
      current: event,
      sliderID: props.id,
    });
  };

  return (
    <OverlaySlider
      sequence={props.sequence}
      highlight={[props.current.start, props.current.end - props.current.start]}
      highlightClass={props.highlightClass}
      onChange={onSliderChange}
      disable={props.disable}
    />
  );
}

Option.propTypes = {
  /**
   * ClassName string to set for component
   */
  className: PropTypes.string.isRequired,
  /**
   * Unique id for slider
   */
  id: PropTypes.number.isRequired,
  /**
   * String sequence to be displayed on slider
   */
  sequence: PropTypes.string.isRequired,
  /**
   * Answer object containing start/end index in sequence and answer substring
   */
  answer: PropTypes.shape({
    /**
     * Answer substring
     */
    text: PropTypes.string,
    /**
     * Start index of answer substring
     */
    start: PropTypes.number,
    /**
     * End index of answer substring
     */
    end: PropTypes.number,
  }),
  current: PropTypes.shape({
    /**
     * current selected substring
     */
    text: PropTypes.string,
    /**
     * Start index of current selected substring
     */
    start: PropTypes.number,
    /**
     * End index of current selected substring
     */
    end: PropTypes.number,
  }),
  /**
   * Color to be set for the highlighted string
   */
  highlightClass: PropTypes.oneOf(["red", "green", "blue", "null"]),
  /**
   * Boolean value specifying the slider is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Callback function to be executed when selection sequence updated
   */
  updateSelection: PropTypes.func.isRequired,
};

Option.defaultProps = {
  className: "",
  sequence: "default",
  answer: {
    text: "de",
    start: 0,
    end: 1,
  },
  current: {
    text: "de",
    start: 0,
    end: 1,
  },
  highlightClass: "null",
  disabled: true,
};
